<template lang="pug">
    footer.global_footer
        | © 2020 cortechne, Inc.
</template>

<script>
export default {
  name: 'publicCopyright',
}
</script>